<fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="'/account'" />

<div class="container d-flex align-items-center">
  <div class="card mx-auto mt-0 align-self-start align-self-lg-center">
    <div class="card-body text-center py-3">
      <div class="card-heading">
        <i class="material-icons me-2 text-danger">add_card</i>
        <h6 class="text-danger mb-0 font-page-heading text-uppercase font-size-14">
          {{ 'ecash.failure.page.title' | translate }}
        </h6>
      </div>
      <div class="mt-4 sub-heading-modal">
        <div class="text-center text-black">{{ 'ecash.failure.page.card.message' | translate }}</div>
      </div>
      <div class="btn-container mt-2 d-block">
        <button [routerLink]="['/account']" type="button" class="btn btn-danger text-white mx-2 mt-4 fw-bold">
          {{ 'ecash.failure.page.close.button' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
